import { render } from "./RegistrationOrderForm.vue?vue&type=template&id=12f90225&scoped=true"
import script from "./RegistrationOrderForm.vue?vue&type=script&lang=js"
export * from "./RegistrationOrderForm.vue?vue&type=script&lang=js"

import "./RegistrationOrderForm.vue?vue&type=style&index=0&id=12f90225&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f90225"]])

export default __exports__